export default __webpack_public_path__ + "static/media/checklist.c1a0b595.png";